import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/homepage/home"; // Import the Home component

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {/* Add additional routes here */}
    </Routes>
  );
};

export default AppRoutes;